
// import React, { useEffect, useState } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { fetchAllDevices } from "../../redux/slices/DeviceSlice";
// import "./AdminCSS/Details.css";

// const API_URL = process.env.REACT_APP_API_URL;

// const BluetoothWiFiConnect = () => {
//   const dispatch = useDispatch();
//   const { devices, loading: loadingDevices, error: devicesError } = useSelector((state) => state.devices);

//   // Bluetooth/Wi-Fi connections from backend keyed by device_mac
//   const [connections, setConnections] = useState({});

//   // Editable state per device_id
//   const [editMode, setEditMode] = useState({});

//   // Form entries per device_id
//   const [formEntries, setFormEntries] = useState({});

//   // Loading state for save operation per device
//   const [savingDevice, setSavingDevice] = useState(null);
//   const [saveError, setSaveError] = useState(null);

//   // Fetch devices and connections on mount
//   useEffect(() => {
//     dispatch(fetchAllDevices());
//     fetchConnections();
//   }, [dispatch]);

//   // Fetch existing connections from backend
//   const fetchConnections = async () => {
//     const token = sessionStorage.getItem("access_token") || localStorage.getItem("access_token");
//     try {
//       const res = await fetch(`${API_URL}/assignments/bluetooth-wifi-connection/`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (!res.ok) throw new Error("Failed to fetch connections");
//       const data = await res.json();
//       const connMap = {};
//       data.forEach((conn) => {
//         connMap[conn.device_mac] = conn;
//       });
//       setConnections(connMap);
//     } catch (e) {
//       console.error(e);
//     }
//   };

//   // Toggle edit mode for a given device
//   const toggleEdit = (deviceId) => {
//     setEditMode((prev) => ({
//       ...prev,
//       [deviceId]: !prev[deviceId],
//     }));

//     // Initialize form entries if enabling edit
//     if (!editMode[deviceId]) {
//       const device = devices.find((d) => d.device_id === deviceId);
//       const conn = connections[device?.mac_address] || {};
//       setFormEntries((prev) => ({
//         ...prev,
//         [deviceId]: {
//           wifiName: conn.wifi_name || "",
//           wifiPassword: conn.wifi_password || "",
//           bluetoothMac: conn.bluetooth_device_mac || "",
//         },
//       }));
//     }
//   };

//   const handleInputChange = (deviceId, field, value) => {
//     setFormEntries((prev) => ({
//       ...prev,
//       [deviceId]: {
//         ...prev[deviceId],
//         [field]: value,
//       },
//     }));
//   };

//   const canSave = (deviceId) => {
//     const e = formEntries[deviceId];
//     return (
//       e &&
//       e.wifiName.trim() !== "" &&
//       e.wifiPassword.trim() !== "" &&
//       e.bluetoothMac.trim() !== ""
//     );
//   };

//   const onSave = async (deviceId) => {
//     const data = formEntries[deviceId];
//     const device = devices.find((d) => d.device_id === deviceId);
//     if (!device) return;

//     setSavingDevice(deviceId);
//     setSaveError(null);

//     try {
//       const token = sessionStorage.getItem("access_token") || localStorage.getItem("access_token");

//       const res = await fetch(`${API_URL}/assignments/bluetooth-wifi-connection/`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//         body: JSON.stringify({
//           device_mac: device.mac_address,
//           bluetooth_device_mac: data.bluetoothMac.trim(),
//           wifi_name: data.wifiName.trim(),
//           wifi_password: data.wifiPassword.trim(),
//         }),
//       });

//       if (!res.ok) {
//         const errData = await res.json();
//         throw new Error(errData.detail || "Save failed");
//       }

//       const updatedConn = await res.json();

//       // Update connections state with saved data
//       setConnections((prev) => ({
//         ...prev,
//         [device.mac_address]: updatedConn,
//       }));

//       // Exit edit mode on success
//       setEditMode((prev) => ({
//         ...prev,
//         [deviceId]: false,
//       }));
//     } catch (err) {
//       setSaveError(err.message);
//     } finally {
//       setSavingDevice(null);
//     }
//   };

//   return (
//     <div className="Devices-page">
//       <h3>Bluetooth & Wi-Fi Connectivity</h3>

//       {(loadingDevices) && <p>Loading devices...</p>}
//       {(devicesError) && <p className="error">{devicesError}</p>}

//       {!loadingDevices && devices.length > 0 && (
//         <div className="table-scroll-container">
//           <table className="device-table">
//             <thead>
//               <tr>
//                 <th>ID</th>
//                 <th>Device MAC</th>
//                 <th>Wi-Fi Name</th>
//                 <th>Wi-Fi Password</th>
//                 <th>Bluetooth MAC</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {devices.map((device, idx) => {
//                 const deviceMac = device.mac_address;
//                 const conn = connections[deviceMac];
//                 const isEditing = !!editMode[device.device_id];
//                 const form = formEntries[device.device_id] || {
//                   wifiName: conn?.wifi_name || "",
//                   wifiPassword: conn?.wifi_password || "",
//                   bluetoothMac: conn?.bluetooth_device_mac || "",
//                 };

//                 return (
//                   <tr key={device.device_id}>
//                     <td>{idx + 1}</td>
//                     <td>{deviceMac}</td>

//                     <td>
//                       <input
//                         type="text"
//                         value={isEditing ? form.wifiName : conn?.wifi_name || ""}
//                         disabled={!isEditing}
//                         onChange={(e) =>
//                           handleInputChange(device.device_id, "wifiName", e.target.value)
//                         }
//                       />
//                     </td>

//                     <td>
//                       <input
//                         type="password"
//                         value={isEditing ? form.wifiPassword : conn?.wifi_password || ""}
//                         disabled={!isEditing}
//                         onChange={(e) =>
//                           handleInputChange(device.device_id, "wifiPassword", e.target.value)
//                         }
//                       />
//                     </td>

//                     <td>
//                       <input
//                         type="text"
//                         value={isEditing ? form.bluetoothMac : conn?.bluetooth_device_mac || ""}
//                         disabled={!isEditing}
//                         onChange={(e) =>
//                           handleInputChange(device.device_id, "bluetoothMac", e.target.value)
//                         }
//                       />
//                     </td>

//                     <td>
//                       {isEditing ? (
//                         <>
//                           <button
//                             className="save-btn"
//                             disabled={!canSave(device.device_id) || savingDevice === device.device_id}
//                             onClick={() => onSave(device.device_id)}
//                           >
//                             {savingDevice === device.device_id ? "Saving..." : "Save"}
//                           </button>
//                           {" "}
//                           <button onClick={() => setEditMode((prev) => ({ ...prev, [device.device_id]: false }))}>
//                             Cancel
//                           </button>
//                           {saveError && savingDevice === device.device_id && (
//                             <div style={{ color: "red", marginTop: "4px" }}>{saveError}</div>
//                           )}
//                         </>
//                       ) : (
//                         <button onClick={() => toggleEdit(device.device_id)}>Edit</button>
//                       )}
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {!loadingDevices && devices.length === 0 && <p>No devices found.</p>}
//     </div>
//   );
// };

// export default BluetoothWiFiConnect;



import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchAllDevices } from "../../redux/slices/DeviceSlice";
import "./AdminCSS/Details.css";

const API_URL = process.env.REACT_APP_API_URL;

const BluetoothWiFiConnect = () => {
  const dispatch = useDispatch();
  const { devices, loading: loadingDevices, error: devicesError } = useSelector(
    (state) => state.devices
  );

  // Bluetooth/Wi-Fi connections from backend keyed by device_mac
  const [connections, setConnections] = useState({});

  // Editable state per device_id
  const [editMode, setEditMode] = useState({});

  // Form entries per device_id
  const [formEntries, setFormEntries] = useState({});

  // Loading state for save operation per device
  const [savingDevice, setSavingDevice] = useState(null);
  const [saveError, setSaveError] = useState(null);

  // Fetch devices and connections on mount
  useEffect(() => {
    dispatch(fetchAllDevices());
    fetchConnections();
    // eslint-disable-next-line
  }, [dispatch]);

  // Fetch existing connections from backend
  const fetchConnections = async () => {
    const token =
      sessionStorage.getItem("access_token") ||
      localStorage.getItem("access_token");
    try {
      const res = await fetch(
        `${API_URL}/assignments/bluetooth-wifi-connection/`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (!res.ok) throw new Error("Failed to fetch connections");
      const data = await res.json();
      const connMap = {};
      data.forEach((conn) => {
        connMap[conn.device_mac] = conn;
      });
      setConnections(connMap);
    } catch (e) {
      console.error(e);
    }
  };

  // Toggle edit mode for a given device
  const toggleEdit = (deviceId) => {
    setEditMode((prev) => ({
      ...prev,
      [deviceId]: !prev[deviceId],
    }));

    // Initialize form entries if enabling edit
    if (!editMode[deviceId]) {
      const device = devices.find((d) => d.device_id === deviceId);
      const conn = connections[device?.mac_address] || {};
      setFormEntries((prev) => ({
        ...prev,
        [deviceId]: {
          wifiName: conn.wifi_name || "",
          wifiPassword: conn.wifi_password || "",
          bluetoothMac: conn.bluetooth_device_mac || "",
        },
      }));
    }
  };

  const handleInputChange = (deviceId, field, value) => {
    setFormEntries((prev) => ({
      ...prev,
      [deviceId]: {
        ...prev[deviceId],
        [field]: value,
      },
    }));
  };

  // Safe canSave implementation
  const canSave = (deviceId) => {
    const e = formEntries[deviceId];
    return (
      e &&
      (e.wifiName || "").trim() !== "" &&
      (e.wifiPassword || "").trim() !== "" &&
      (e.bluetoothMac || "").trim() !== ""
    );
  };

  const onSave = async (deviceId) => {
    const data = formEntries[deviceId] || {};
    const device = devices.find((d) => d.device_id === deviceId);
    if (!device) return;

    setSavingDevice(deviceId);
    setSaveError(null);

    try {
      const token =
        sessionStorage.getItem("access_token") ||
        localStorage.getItem("access_token");

      const res = await fetch(
        `${API_URL}/assignments/bluetooth-wifi-connection/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            device_mac: device.mac_address,
            bluetooth_device_mac: (data.bluetoothMac || "").trim(),
            wifi_name: (data.wifiName || "").trim(),
            wifi_password: (data.wifiPassword || "").trim(),
          }),
        }
      );

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.detail || "Save failed");
      }

      const updatedConn = await res.json();

      // Update connections state with saved data
      setConnections((prev) => ({
        ...prev,
        [device.mac_address]: updatedConn,
      }));

      // Exit edit mode on success
      setEditMode((prev) => ({
        ...prev,
        [deviceId]: false,
      }));
    } catch (err) {
      setSaveError(err.message);
    } finally {
      setSavingDevice(null);
    }
  };

  // Styles
  const inputStyle = {
    width: "160px",
    marginRight: "10px",
    padding: "7px 10px",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "4px",
  };

  return (
    <div className="Devices-page">
      <h3>Bluetooth & Wi-Fi Connectivity</h3>

      {loadingDevices && <p>Loading devices...</p>}
      {devicesError && <p className="error">{devicesError}</p>}

      {!loadingDevices && devices.length > 0 && (
        <div className="table-scroll-container">
          <table className="device-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Device MAC</th>
                <th>Wi-Fi Name</th>
                <th>Wi-Fi Password</th>
                <th>Bluetooth MAC</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {devices.map((device, idx) => {
                const deviceMac = device.mac_address;
                const conn = connections[deviceMac];
                const hasConnection =
                  conn &&
                  (conn.wifi_name || "") !== "" &&
                  (conn.wifi_password || "") !== "" &&
                  (conn.bluetooth_device_mac || "") !== "";
                const isEditing = !!editMode[device.device_id];
                const form = formEntries[device.device_id] || {
                  wifiName: conn?.wifi_name || "",
                  wifiPassword: conn?.wifi_password || "",
                  bluetoothMac: conn?.bluetooth_device_mac || "",
                };

                return (
                  <tr key={device.device_id}>
                    <td>{idx + 1}</td>
                    <td>{deviceMac}</td>

                    <td>
                      <input
                        type="text"
                        style={inputStyle}
                        value={
                          isEditing || !hasConnection
                            ? form.wifiName || ""
                            : conn?.wifi_name || ""
                        }
                        disabled={!isEditing && hasConnection}
                        onChange={(e) =>
                          handleInputChange(
                            device.device_id,
                            "wifiName",
                            e.target.value
                          )
                        }
                        autoComplete="off"
                      />
                    </td>

                    <td>
                      <input
                        type="password"
                        style={inputStyle}
                        value={
                          isEditing || !hasConnection
                            ? form.wifiPassword || ""
                            : conn?.wifi_password || ""
                        }
                        disabled={!isEditing && hasConnection}
                        onChange={(e) =>
                          handleInputChange(
                            device.device_id,
                            "wifiPassword",
                            e.target.value
                          )
                        }
                        autoComplete="off"
                      />
                    </td>

                    <td>
                      <input
                        type="text"
                        style={inputStyle}
                        value={
                          isEditing || !hasConnection
                            ? form.bluetoothMac || ""
                            : conn?.bluetooth_device_mac || ""
                        }
                        disabled={!isEditing && hasConnection}
                        onChange={(e) =>
                          handleInputChange(
                            device.device_id,
                            "bluetoothMac",
                            e.target.value
                          )
                        }
                        autoComplete="off"
                      />
                    </td>

                    <td>
                      {hasConnection && !isEditing ? (
                        <button className="save-btn" onClick={() => toggleEdit(device.device_id)}>
                          Edit
                        </button>
                      ) : (
                        <>
                          <button
                            className="save-btn"
                            disabled={
                              !canSave(device.device_id) ||
                              savingDevice === device.device_id
                            }
                            onClick={() => onSave(device.device_id)}
                          >
                            {savingDevice === device.device_id
                              ? "Saving..."
                              : "Save / Update"}
                          </button>
                          {isEditing && (
                            <button
                            className="save-btn"
                              onClick={() =>
                                setEditMode((prev) => ({
                                  ...prev,
                                  [device.device_id]: false,
                                }))
                              }
                              style={{ marginLeft: 8 }}
                            >
                              Cancel
                            </button>
                          )}
                          {saveError && savingDevice === device.device_id && (
                            <div style={{ color: "red", marginTop: "4px" }}>
                              {saveError}
                            </div>
                          )}
                        </>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {!loadingDevices && devices.length === 0 && <p>No devices found.</p>}
    </div>
  );
};

export default BluetoothWiFiConnect;

